import type { ValueProvider } from '@angular/core';
import { InjectionToken } from '@angular/core';

export enum CoverLetterType {
  FILE,
  TEXT,
}

export const clAcceptedFileTypes = [
  '.doc',
  '.docx',
  '.pdf',
  '.odt',
  '.rtf',
  '.html',
  '.htm',
  '.txt',
  '.jpg',
  '.jpeg',
  '.jpe',
  '.png',
  '.gif',
  '.jfif',
  '.webp',
];

export interface CLEmptyStateI18n {
  title: string;
  message: string;
  support?: string;
  download?: string;
}

export const CL_EMPTY_STATE_I18N = new InjectionToken<CLEmptyStateI18n>('CL_EMPTY_STATE_I18N');

export const CLEmptyStateI18nProvider = (keys: CLEmptyStateI18n): ValueProvider => ({
  provide: CL_EMPTY_STATE_I18N,
  useValue: keys,
});
